import { useHistory } from 'react-router-dom';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const FlowAlertView = ({
  alert,
  viewData,
  flow,
  onCancel
}) => {
  const history = useHistory();
  return /*#__PURE__*/_jsx(Alert, {
    type: alert.alertType,
    marginBlockStart: "300",
    children: alert.getMessage({
      viewData,
      flow,
      history,
      onCancel
    })
  });
};
export default FlowAlertView;